import { RoomRate } from '@niarab2c/frontend-commons/src/types/hotels';
import { NiaraIcon } from '@niaratech/niara-icons';
import { ResponsiveTooltip } from '@niaratech/niara-react-components';
import React from 'react';
import { ModalOTA, ModalOTAProps } from '../../';
import * as S from './styles';
interface MealProps {
  /**
   * Respeitando o meal vindo do roomRate.meal.
   *
   * Buscando descrição do meal dentro dos meals existentes no roomRate.descriptions.meal
   * `#226114`
   */
  meal?: RoomRate['meal'];
  mealDescriptions?: RoomRate['descriptions']['meal'];
}
const Meal: React.FC<MealProps> = (props: MealProps) => {
  const {
    meal: mealProps,
    mealDescriptions
  } = props;
  const meal = {
    name: mealProps?.name,
    description: mealDescriptions?.find(_meal => _meal?.name === mealProps?.name)?.description
  };
  if (meal?.name) {
    return <S.MealContainer>
        <ResponsiveTooltip<ModalOTAProps> modalComponent={ModalOTA} ModalProps={{
        title: 'Refeição'
      }} renderContent={() => <S.MealTooltipContent>
              <p className="bold">{meal?.name}</p>
              {meal?.description && <p>{meal?.description}</p>}
            </S.MealTooltipContent>}>
          <S.MealContent>
            <NiaraIcon icon="htlBreakfastOutlined" />
            <span style={{
            fontWeight: 600
          }}>{meal?.name}</span>
          </S.MealContent>
        </ResponsiveTooltip>
      </S.MealContainer>;
  }
  return <S.MealContent>
      <NiaraIcon icon="sysBlocked" />
      <span>Sem refeição inclusa</span>
    </S.MealContent>;
};
export default Meal;